import { ROVO_SEARCH_PAGE, ROVO_SEARCH_PATH } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';

export const rovoSearchRoute = createGlobalRoute({
	exact: true,
	name: ROVO_SEARCH_PAGE,
	path: ROVO_SEARCH_PATH,
	layout: 'home',
	nav4Layout: 'expanded',
});
